import PropTypes from 'prop-types';
import React from 'react';

import { SubMenuContainer, SubMenuOption } from './TrlPopoverSubMenu.styles';

export const TrlPopoverSubMenu = ({
  onboardingPopoverAnchor,
  handleClosePopover,
  popoverWidth,
  subMenuOptions,
  handleOptionClick,
}) => (
  <SubMenuContainer
    open={Boolean(onboardingPopoverAnchor)}
    anchorEl={onboardingPopoverAnchor}
    onClose={handleClosePopover}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    width={popoverWidth}
  >
    {subMenuOptions.map((option) => (
      <SubMenuOption
        key={option.value}
        onClick={() => handleOptionClick(option)}
      >
        {option.description}
      </SubMenuOption>
    ))}
  </SubMenuContainer>
);

TrlPopoverSubMenu.propTypes = {
  onboardingPopoverAnchor: PropTypes.object.isRequired,
  handleClosePopover: PropTypes.func.isRequired,
  popoverWidth: PropTypes.string,
  subMenuOptions: PropTypes.arr,
  handleOptionClick: PropTypes.func,
};
